/** NL/EN language toggle in the account menu — persists via setLocale. */
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { setLocale, useCurrentLocale, useT } from '@/i18n/useT';
import {
  SETTINGS_LANGUAGE_EN_TEST_ID,
  SETTINGS_LANGUAGE_NL_TEST_ID,
  SETTINGS_LANGUAGE_SECTION_TEST_ID,
} from '@/features/settings/constants/settingsTestIds';

export default function AccountMenuLanguagePreference() {
  const t = useT();
  const locale = useCurrentLocale();

  const handleLocaleChange = (_event, nextLocale) => {
    if (nextLocale) setLocale(nextLocale);
  };

  return (
    <Box
      component="li"
      data-testid={SETTINGS_LANGUAGE_SECTION_TEST_ID}
      sx={{
        listStyle: 'none',
        px: 2,
        py: 1,
        borderTop: 1,
        borderBottom: 1,
        borderColor: 'divider',
      }}
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <Typography
        variant="caption"
        component="p"
        color="text.secondary"
        sx={{ mb: 0.5, display: 'flex', alignItems: 'center', gap: 0.5 }}
        id="account-menu-language-label"
      >
        <LanguageIcon aria-hidden="true" sx={{ fontSize: '1rem' }} />
        {t('settings.language.title', 'Language')}
      </Typography>
      <ToggleButtonGroup
        exclusive
        fullWidth
        value={locale}
        onChange={handleLocaleChange}
        aria-labelledby="account-menu-language-label"
        aria-label={t('settings.language.ariaLabel', 'App language')}
        size="small"
      >
        <ToggleButton value="nl" data-testid={SETTINGS_LANGUAGE_NL_TEST_ID}>
          {t('settings.language.option.nl', 'Nederlands')}
        </ToggleButton>
        <ToggleButton value="en" data-testid={SETTINGS_LANGUAGE_EN_TEST_ID}>
          {t('settings.language.option.en', 'English')}
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}
